import { __decorate, __metadata } from 'tslib';
import * as i0 from '@angular/core';
import { Directive, ElementRef, Component, ChangeDetectionStrategy, Input, HostBinding } from '@angular/core';
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';
import { distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { ReplaySubject } from 'rxjs';
let NgDocSelectionHostDirective = /*#__PURE__*/(() => {
  class NgDocSelectionHostDirective {
    constructor() {
      this.origins = new Set();
      this.selectedChange = new ReplaySubject();
    }
    get selectedChange$() {
      return this.selectedChange.pipe(distinctUntilChanged());
    }
    addOrigin(origin) {
      this.origins.add(origin);
    }
    removeOrigin(origin) {
      this.origins.delete(origin);
      if (this.selected === origin) {
        this.changeSelected(origin, false);
      }
    }
    changeSelected(origin, selected) {
      this.selected = this.selected === origin || selected ? selected ? origin : undefined : this.selected;
      this.selectedChange.next(this.selected?.elementRef?.nativeElement ?? undefined);
    }
    static {
      this.ɵfac = function NgDocSelectionHostDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocSelectionHostDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: NgDocSelectionHostDirective,
        selectors: [["", "ngDocSelectionHost", ""]],
        standalone: true
      });
    }
  }
  return NgDocSelectionHostDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgDocSelectionComponent = /*#__PURE__*/(() => {
  let NgDocSelectionComponent = class NgDocSelectionComponent {
    constructor(elementRef, selectionHost) {
      this.elementRef = elementRef;
      this.selectionHost = selectionHost;
      this.align = 'bottom';
    }
    ngAfterViewInit() {
      this.selectionHost.selectedChange$.pipe(debounceTime(0), untilDestroyed(this)).subscribe(selected => this.setStyles(selected));
    }
    setStyles(element) {
      this.elementRef.nativeElement.style.visibility = 'hidden';
      if (element) {
        const position = this.getPosition(element);
        if (this.align === 'left' || this.align === 'right') {
          this.elementRef.nativeElement.style.top = position.top;
        } else {
          this.elementRef.nativeElement.style.left = position.left;
        }
        this.elementRef.nativeElement.style.height = position.height;
        this.elementRef.nativeElement.style.width = position.width;
        this.elementRef.nativeElement.style.visibility = 'visible';
      }
    }
    getPosition(element) {
      return {
        top: element ? `${element.offsetTop || 0}px` : '0',
        left: element ? `${element.offsetLeft || 0}px` : '0',
        width: element ? `${element.offsetWidth || 0}px` : '0',
        height: element ? `${element.offsetHeight || 0}px` : '0'
      };
    }
    static {
      this.ɵfac = function NgDocSelectionComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocSelectionComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(NgDocSelectionHostDirective));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgDocSelectionComponent,
        selectors: [["ng-doc-selection"]],
        hostVars: 1,
        hostBindings: function NgDocSelectionComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("data-ng-doc-align", ctx.align);
          }
        },
        inputs: {
          align: "align"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 0,
        vars: 0,
        template: function NgDocSelectionComponent_Template(rf, ctx) {},
        styles: ["[_nghost-%COMP%]{position:absolute;transition:var(--ng-doc-transition);pointer-events:none;background:var(--ng-doc-selection-background)}[data-ng-doc-align=left][_nghost-%COMP%]{left:0;border-left:var(--ng-doc-selection-border)}[data-ng-doc-align=right][_nghost-%COMP%]{right:0;border-right:var(--ng-doc-selection-border)}[data-ng-doc-align=bottom][_nghost-%COMP%]{bottom:0;border-bottom:var(--ng-doc-selection-border)}[data-ng-doc-align=top][_nghost-%COMP%]{top:0;border-top:var(--ng-doc-selection-border)}"],
        changeDetection: 0
      });
    }
  };
  NgDocSelectionComponent = __decorate([UntilDestroy(), __metadata("design:paramtypes", [ElementRef, NgDocSelectionHostDirective])], NgDocSelectionComponent);
  return NgDocSelectionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgDocSelectionOriginDirective = /*#__PURE__*/(() => {
  class NgDocSelectionOriginDirective {
    constructor(elementRef, selectionHost) {
      this.elementRef = elementRef;
      this.selectionHost = selectionHost;
      this.selected = false;
      this.selectionHost.addOrigin(this);
    }
    ngOnChanges({
      selected
    }) {
      if (selected) {
        this.selectionHost.changeSelected(this, this.selected);
      }
    }
    ngOnDestroy() {
      this.selectionHost.removeOrigin(this);
    }
    static {
      this.ɵfac = function NgDocSelectionOriginDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocSelectionOriginDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(NgDocSelectionHostDirective));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: NgDocSelectionOriginDirective,
        selectors: [["", "ngDocSelectionOrigin", ""]],
        inputs: {
          selected: [0, "ngDocSelectionOrigin", "selected"]
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return NgDocSelectionOriginDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocSelectionComponent, NgDocSelectionHostDirective, NgDocSelectionOriginDirective };
